import React from 'react';
import { Users, Rocket, TrendingUp, Globe } from 'lucide-react';

export const TrustBanner = () => {
  const metrics = [
    { value: '500+', label: 'Active Customers', icon: Users },
    { value: '10,000+', label: 'Deployments', icon: Rocket },
    { value: '99.99%', label: 'Uptime Guarantee', icon: TrendingUp },
    { value: '5 Cities', label: 'Data Centers', icon: Globe }
  ];

  return (
    <section className="py-12 md:py-20 bg-[#0A0E14] relative overflow-hidden border-y border-white/5">
      <div className="absolute inset-0 pro-grid opacity-20"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {metrics.map((metric, index) => {
            const Icon = metric.icon;
            return (
              <div 
                key={index}
                className="text-center"
                style={{ animation: 'fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards', animationDelay: `${index * 100}ms`, opacity: 0 }}
              >
                <div className="flex justify-center mb-2 md:mb-3">
                  <Icon className="text-green-400" size={20} />
                </div>
                <div className="text-2xl md:text-3xl font-bold text-white mb-1">
                  {metric.value}
                </div>
                <div className="text-xs md:text-sm text-gray-500">
                  {metric.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};